import { useQuery } from 'react-query';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

import { getFeedPost } from '../requests/getFeedPost';
import { getTopicPost } from '../requests/getTopicPost';
import type { UserPostProps } from '../types';

export interface UseUserPostParams {
  initialData?: UserPostProps;
  isTopicPost: boolean;
  topicId?: number;
  userPostId?: number;
}

export const useUserPost = ({
  initialData,
  isTopicPost,
  topicId,
  userPostId,
}: UseUserPostParams): UserPostProps | undefined => {
  const { currentUser } = useDefaultAppContexts();

  const { data: userPost } = useQuery(
    ['userpost', topicId, userPostId],
    () =>
      isTopicPost && topicId
        ? getTopicPost({ topicId, userPostId })
        : getFeedPost({ currentUserId: currentUser!.id, userPostId }),
    { enabled: !initialData, initialData },
  );

  return userPost;
};
